import { useNavigate } from "react-router-dom";
import PhoneFrame from "./PhoneFrame";
import logoSplash from "../../assets/images/logo-splash.png";
import skylineLight from "../../assets/images/splash-skyline-light.png";
import driverTaxi from "../../assets/images/driver-taxi.png";

export default function AuthLayout({ children, previousPage }) {
  const navigate = useNavigate();

  return (
    <PhoneFrame className="bg-scabWhite" scroll={false}>
      <div className="h-full flex flex-col relative overflow-y-auto overflow-x-hidden phone-scroll">
        <img
          src={skylineLight}
          alt=""
          className="absolute inset-0 w-full h-full object-cover object-bottom pointer-events-none"
        />
        <header className="relative z-10 w-full h-[52px] bg-scabDarkYellow flex justify-end items-center px-4 shrink-0">
          <button
            type="button"
            className="w-[32px] h-[32px] flex justify-center items-center"
            onClick={() => navigate(previousPage)}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="22"
              height="22"
              viewBox="0 0 1024 1024"
            >
              <path
                fill="currentColor"
                d="M685.248 104.704a64 64 0 0 1 0 90.496L368.448 512l316.8 316.8a64 64 0 0 1-90.496 90.496L232.704 557.248a64 64 0 0 1 0-90.496l362.048-362.048a64 64 0 0 1 90.496 0"
              />
            </svg>
          </button>
        </header>

        <div className="relative z-10 flex flex-col items-center px-6 pt-6 pb-4">
          <img src={logoSplash} alt="اسکب" className="w-[120px] h-auto" />
        </div>

        <div className="relative z-10 flex-1 flex flex-col items-center px-6 w-full">
          {children}
        </div>

        <div className="relative z-10 w-full flex justify-center mt-auto pt-4 pb-2">
          <img src={driverTaxi} alt="" className="w-[280px] h-auto" />
        </div>
      </div>
    </PhoneFrame>
  );
}
